export default __webpack_public_path__ + "static/media/09_photo.2ed08f1a.jpeg";